import type { RepeatFrequency, RepeatRule } from "@desk/contracts";

const UNIT: Record<Exclude<RepeatFrequency, "weekdays">, [string, string]> = {
  daily: ["day", "days"],
  weekly: ["week", "weeks"],
  monthly: ["month", "months"],
  yearly: ["year", "years"],
};

/** "Every day", "Every 2 weeks", "Every weekday", "Every month after completion". */
export function repeatLabel(rule: RepeatRule): string {
  const base =
    rule.frequency === "weekdays"
      ? "Every weekday"
      : rule.interval === 1
        ? `Every ${UNIT[rule.frequency][0]}`
        : `Every ${rule.interval} ${UNIT[rule.frequency][1]}`;
  return rule.from === "completion" ? `${base} after completion` : base;
}

export const sameRule = (a: RepeatRule | null, b: RepeatRule | null) =>
  a === b || (!!a && !!b && a.frequency === b.frequency && a.interval === b.interval && a.from === b.from);

export const REPEAT_PRESETS: RepeatRule[] = (["daily", "weekdays", "weekly", "monthly", "yearly"] as const).map((frequency) => ({
  frequency,
  interval: 1,
  from: "schedule",
}));

export const REPEAT_UNITS = Object.entries(UNIT).map(([value, [one, many]]) => ({ value, one, many })) as {
  value: Exclude<RepeatFrequency, "weekdays">;
  one: string;
  many: string;
}[];
